/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNodeNotarizationTooltip', ['template', function(template) {
        return {
            scope: {
                notarization: '=accNodeNotarizationTooltip',
                isPreviousRevisionNotarization: '='
            },
            transclude: true,
            templateUrl: template('nodes/_node_notarization_tooltip'),
            link: function($scope) {
                $scope.getStatusMessage = function() {
                    if($scope.isPreviousRevisionNotarization) {
                        if(isNotarizationSuccessful()) {
                            return 'node_notarization_indicator_tooltip_previous_revision_successful';
                        } else {
                            return 'node_notarization_indicator_tooltip_previous_revision_in_progress'
                        }
                    } else {
                        if(isNotarizationSuccessful()) {
                            return 'node_notarization_indicator_tooltip_latest_revision_successful';
                        } else {
                            return 'node_notarization_indicator_tooltip_latest_revision_in_progress';
                        }
                    }
                };

                function isNotarizationSuccessful() {
                    return $scope.notarization['status'] === 'successful';
                }
            }
        }
    }]);
